import { createValidator, getFormFieldNames } from './yupHelper';
/**
 * A hook that provides form validation and field name information for a Yup schema in a Final Form.
 *
 * @template T - The type of the Yup schema.
 * @param {IUseFinalFormYupFormHelpers<T>} props - An object containing the Yup schema to use for form validation.
 * {@link IUseFinalFormYupFormHelpers IUseFinalFormYupFormHelpers}
 * @returns {readonly [ValidationFunction<T>, FormNames<T>]} - A tuple containing the form validation function and an object containing the names of all the form fields in the schema.
 * {@link ValidationFunction ValidationFunction}
 */
var useFinalFormYupFormHelpers = function (props) {
    var validate = createValidator(props.schema);
    var formNames = getFormFieldNames(props.schema);
    return [validate, formNames];
};
export default useFinalFormYupFormHelpers;
//# sourceMappingURL=useFinalFormYupFormHelpers.js.map